import { BaseService } from '@adgate/common/services/base-service';
import { Service } from '@angular/core';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';

export interface ChatMessage 
{
  content: string;
  isBot: boolean;
  timestamp: number;
}

export interface ChatRequest 
{
  message: string;
  history: ChatMessage[];
}

@Service()
export class AssistantService extends BaseService
{
  private baseServiceUrl = `${environment.baseServiceUrl}assistant`;

  getBaseServiceUrl()
  {
    return this.baseServiceUrl;
  }

  /**
   * Send a chat message to the assistant backend
   * @param message The user's message
   * @param history The conversation history
   * @returns Observable with the assistant's reply
   */
  sendMessage(message: string, history: ChatMessage[]): Observable<any>
  {
    const url = `${this.baseServiceUrl}/chat`;
    const payload: ChatRequest = {
      message: message,
      history: history
    };
    return this.sendRequest(url, payload, 'post');
  }
}
